<template>
    <TaskAssigneeAvatars
        v-if="assignees"
        :task-assignees="assignees"
    />
</template>

<script>
import AccountAvatar from "@/components/AccountAvatar";
import TaskAssigneeAvatars from "@/views/Task/TaskAssigneeAvatars";

export default {

    name: "RichDataTableClientAvatar",
    components: {
        AccountAvatar,
        TaskAssigneeAvatars
    },
    props: {
        assignees: {
            type: Array,
            default: null
        },
    },
    setup(props, ctx) {


        return {
        };
    }
};
</script>
